// extracted by mini-css-extract-plugin
export default {"fileTypeImage":"FileDocumentDataHelper_fileTypeImage__w6T6k"};